import {AnnualAccountingDocumentCount} from "apps/console/src/app/subsidiaries-module/enums";
import {ISubsidiaryForm} from "apps/console/src/app/subsidiaries-module/models";
import {IAccountInformationModel} from "apps/console/src/app/user-module/models";

export function checkAccountCreationIsForbidden(user: IAccountInformationModel, subsidiary: ISubsidiaryForm): boolean|string {
	// User Story 19682: 🎮[ACC][Console][MO] Création d'une entreprise par l'utilisateur Support Aston AI
	if (user?.isSupport) return false;

	// User Story 16322: 🎮[ACC][Onboarding]Processus de création entreprise - Votre entreprise
	// User Story 20544: 🎮[Onboarding] Limiter la création d'une plateforme en autonomie: volumétrie limitée à 10000 pièces
	if (+subsidiary.annualAccountingDocumentCount > +AnnualAccountingDocumentCount.Range2)
		return 'InvalidDocumentsCount';

	// User Story 20547: 🎮[Onboarding] Limiter la création d'une plateforme en autonomie: Création limitée aux entreprises françaises
	const arrAuthorizedCountries = ["FR", "GF", "GP", "MQ", "YT", "RE", "BL", "MF", "PM"];
	if (!(arrAuthorizedCountries.includes(subsidiary.countryCode)))
		return 'InvalidCountry';

	// User Story 20549: 🎮[Onboarding] Limiter la création d'une plateforme en autonomie: Création limitée à 5 entreprises par utilisateur
	// if (currentSubsidiaries.filter(s => s.accessLevel === AccessLevel.Admin && (s.status === SubsidiaryStatus.Registered || s.status === SubsidiaryStatus.Initialized)).length >= 5)
	//     return 'InvalidSubsidiariesCount';

	return false;
}
